<template>
<transition name="Defi2">
  <div class="Defi2">

    <transition name="Defi2__hint">
      <div class="Defi2__hint" v-if="slugIsIn(['15', 'defi2:1', 'defi2:2', 'defi2:3']) && ready">
        <img :src="require('./img/assets/important.png')"/>
        <div v-html="trans('sentence')" v-if="slugIsIn(['defi2:1', 'defi2:2', 'defi2:3'])"/>
        <div v-html="trans('observe')" v-if="slugIsIn(['15'])"/>
      </div>
    </transition>

    <div class="Defi2__cover">

      <div 
        class="Defi2__oeuvre Vlazy" 
        v-lazy:background-image="oeuvre.image.sizes.large" 
        v-if="oeuvre.id != 214 && oeuvre.id != 226"/>
      
      <transition name="Defi2__infos">
        <div class="Defi2__infos">
          <div class="Defi2__infos-title">{{ oeuvre[oeuvre.titre_original].title }}</div>
          <div class="Defi2__infos-author">{{ author }} / {{ oeuvre.year }}</div>
        </div>  
      </transition>
    </div>

    <VideoComp 
      :indice="(oeuvre.id == 214) ? 'adad' : 'patrick'" 
      v-if="slugIsIn(['15', 'defi2:1', 'defi2:2', 'defi2:3']) && oeuvre.id == 214 || slugIsIn(['15', 'defi2:1', 'defi2:2', 'defi2:3']) && oeuvre.id == 226"/>   

    <Dropzone/> 
    <Emotions v-if="slugIsIn(['defi2:1', 'defi2:2', 'defi2:3'])" :oeuvre_id="oeuvre.id" /> 
    <transition name="Defi2__end">
      <div
        v-if="completed && slugIsIn(['defi2:1', 'defi2:2', 'defi2:3'])"
        class="Btn Defi2__end"
        @click="next" v-html="trans('Global.btn.completed')" />
    </transition> 
  </div>
</transition>
</template>

<script>
import { Draggable } from 'gsap/all'
import Dropzone from './components/Dropzone'
import Emotions from './components/Emotions'
import TweenMax from 'gsap'
import VideoComp from './components/VideoComp'

export default {
  name: 'Defi2',
  components: { Dropzone, Emotions, VideoComp },
  data: () => ({
    completed: false,
    ready: false,
    dropzone: null,
    dropped: [ null ],
    last: null,
    author: ''
  }),
  beforeDestroy() {
    this.$store.commit('app/DRAG_END', null)
  },
  created() {
    this.author = this.oeuvre.author.split('(2)')[0]
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        // if(this.slugIsIn(['defi2:1', 'defi2:2', 'defi2:3'])) {
        //   this.$nextTick(() =>{
        //     TweenMax.delayedCall(.5, ()=>this.Initialize())
        //   })   
        // }

        this.ready = false
        this.$nextTick(() =>{
          if(this.slugIsIn(['defi2:1', 'defi2:2', 'defi2:3'])) 
            TweenMax.delayedCall(.5, ()=>this.Initialize()) 
          this.ready = true
        }) 

      }
    },
    drag_back(nw, od) {  
      const target = this.dropped[nw.choice]
      this.backDragCompleted(target, 0) 
      this.dropped[nw.choice] = null
    },
  },
  computed: {
    current_drag() { return this.$store.getters['app/current_drag'] },
    drag_back() { return this.$store.getters['app/drag_back'] },
  },
  translations: {
    fr: {
      sentence: "Que ressens-tu devant ce portrait ?",
      observe: "Parmi les visages d’Enki, glisse celui qui représente l’émotion que tu ressens quand tu regardes cette œuvre."
    },
    en: {
      sentence: "What do you feel when you look</br>at this portrait?",
      observe: "From among the Enki faces, drag over the one that represents the emotion you feel when you look at this artwork."
    },
  },
  mounted() {
    this.$memory = null
  },
  methods: {
    enter(el, done) {
      TweenMax.from(el, 1, { alpha: 0, scale: .7, onComplete: done })
    },
    leave(el, done) {
      TweenMax.to(el, 1, { alpha: 0, scale: .7, onComplete: done })
    },
    Initialize() {
      this.createDrag()
    },
    createDrag() {
      const _this = this
      this.dropzone = '#dropzone'
      this.$drag = Draggable.create('.draggable', {
        bounds: window,
        zIndexBoost: false,
        onDragStart() {
          _this.$store.commit('app/CURRENT_DRAG', { id: this.target.id })
        },
        onDragEnd() {
          if(this.hitTest(_this.dropzone, '50%')) {
            let delay = 0
            if(_this.dropped[0]) {
              _this.$store.commit('app/DRAG_BACK', { choice: 0, id: _this.dropped[0].id })
              delay = .1
            }
            TweenMax.delayedCall(delay, ()=> _this.dragCompleted(this.target, .5, 0)) 
          }
          else 
            _this.backDragCompleted(this.target, .5) 
        }
      })
    },
    backDragCompleted(target, speed) {
      TweenMax.to(target, speed, { 
        x: 0, 
        y: 0, 
        onComplete: ()=> { 
          this.isCompleted()
          this.$store.commit('app/CURRENT_DRAG', null) 
        }
      }) 
    },
    dragCompleted(target, speed, choice) {
      this.dropped[choice] = target
      this.$store.commit('app/DRAG_END', { id: target.id, choice: choice })
      this.isCompleted()
    },
    isCompleted() {
      TweenMax.delayedCall(.2, ()=>{
        this.completed = (this.getChoice() == -1) ? true : false
      })
    },
    getChoice() {
      let zone = -1
      _.each(this.dropped, (d, i)=>{
        if(d == null && zone == -1) 
          zone = i
      })
      return zone
    }, 
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Defi2
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  transition opacity 1s, transform 1s
  &-enter
  &-leave-active
    opacity 0
    transform scale(.7)

  &__infos
    position absolute
    text-align center
    bottom 100%
    margin-bottom 5px
    width 100%
    display flex
    flex-direction column
    justify-content center
    align-items center

    &-author
      font-size 14px
      font-weight 300
      text-transform uppercase
      
    &-title
      font-size 16px
      text-transform uppercase
      font-style italic
      max-width 70vw

  &__end
    transition opacity .5s, transform .5s
    &-enter
    &-leave-active
      opacity 0
      transform translateY(20px)

  &__cover
    width 100vw
    max-width 600px
    height 400px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)

    +max-screen-height(tablet-portrait)
      width 100%
      height 40%
      max-height 400px

  &__oeuvre
    width 100vw
    max-width 700px
    height 400px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background-size contain
    background-position center center
    background-repeat no-repeat

    +max-screen-height(tablet-portrait)
      height 100%
      width 100%

  &__hint
    position absolute
    min-width 400px
    max-width 600px
    background black
    padding 16px
    border-radius 16px
    left 50%
    transform translateX(-50%)
    margin-top 80px
    text-align center
    color white
    bottom 48px
    opacity 1
    transition opacity 1s
    transition-delay 1s
    &-enter
    &-leave-active
      opacity 0

    +max-screen-height(tablet-portrait)
      font-size 16px
      line-height 22px
      padding 12px
      min-width 360px
      border-radius 8px

    & img 
      position absolute
      top -15px
      left -16px

      +max-screen-height(tablet-portrait)
        width 28px
        left -3px
        top -15px

</style>



// WEBPACK FOOTER //
// src/components/defis/Defi2.vue